export default __webpack_public_path__ + "static/media/typescript.70669f27.svg";